import { ISelectOption } from 'components/forms/Selects'
import { $enum } from 'ts-enum-util'
import { capitalize } from 'utils/capitalize'

export enum TAB {
  ALL = 'All',
  PENDING = 'Pending',
  READY_FOR_DISPATCH = 'Ready for Dispatch',
  ACTIVE = 'Active',
  DELIVERED = 'Delivered',
  INVOICED = 'Invoiced',
  ARCHIVED = 'Archived',
}

export enum POST_DELIVERY_LOAD_STATES {
  'invoiced',
  'completed',
  'payment_pending',
  'pod_rejected',
}

export enum STOP_TYPE {
  pickup = 'pickup',
  dropoff = 'dropoff',
}

export enum UNIT_TYPE {
  cases = 'Cases',
  pallets = 'Pallets',
  truckload = 'Truckload',
  other = 'Other',
}

export enum TIME_TYPE {
  appointment = 'Appointment',
  window = 'Appointment Window',
}

export enum EQUIPMENT_TYPE {
  'Dry Van' = 'dry_van',
  Reefer = 'reefer',
  Flatbed = 'flatbed',
  'Step Deck' = 'step_deck',
  'Double Drop Deck' = 'double_drop_deck',
  Conestoga = 'conestoga',
  Tanker = 'tanker',
  Specialized = 'specialized',
}

export const TRAILER_TYPES = {
  [EQUIPMENT_TYPE['Dry Van']]: [53, 48, 45, 43, 42, 40, 36, 32, 28, 20],
  [EQUIPMENT_TYPE.Reefer]: [53, 51, 48, 40, 36, 32, 28, 'Space Saver'],
  [EQUIPMENT_TYPE.Flatbed]: [53, 48, 45, 42, 40, 'Extendable'],
  [EQUIPMENT_TYPE['Step Deck']]: [53, 48],
  [EQUIPMENT_TYPE['Double Drop Deck']]: [53, 48],
  [EQUIPMENT_TYPE.Conestoga]: [53, 48],
  [EQUIPMENT_TYPE.Tanker]: [53, 50, 48, 45, 43, 32, 40],
  [EQUIPMENT_TYPE.Specialized]: [],
}

export enum TEMPERATURE_TYPE {
  fixed = 'fixed',
  continuous = 'continuous',
}

export enum SUBSCRIBER_NOTIFICATION_TYPE {
  ALL_STATUSES = 'all_statuses',
  ACTIVE_STATUSES = 'active_statuses',
}

export enum CUSTOMER_LABELS_TYPE {
  TARGET_DEDICATED = 'target_dedicated',
}

export enum LOAD_STATE {
  'Pending' = 'pending',
  'Ready for Dispatch' = 'ready_for_dispatch',
  Dispatched = 'dispatched',
  'At Pickup' = 'at_pickup',
  Loading = 'loading',
  'In Transit' = 'in_transit',
  'In Yard' = 'in_yard',
  'At Dropoff' = 'at_dropoff',
  Unloading = 'unloading',
  Delivered = 'delivered',
  Invoiced = 'invoiced',
  Completed = 'completed',
  Cancelled = 'cancelled',
  TONU = 'tonu',
  Claim = 'claim',
  'Payment Pending' = 'payment_pending',
  'POD Rejected' = 'pod_rejected',
}

export enum LOAD_TABS {
  loadDetails = 'Load Details',
  comments = 'Comments',
  documents = 'Documents',
  activity = 'Activity',
}

export const TAB_STATUSES = {
  [TAB.ALL]: [],
  [TAB.PENDING]: [LOAD_STATE.Pending],
  [TAB.READY_FOR_DISPATCH]: [LOAD_STATE['Ready for Dispatch']],
  [TAB.ACTIVE]: [
    LOAD_STATE.Dispatched,
    LOAD_STATE['At Pickup'],
    LOAD_STATE.Loading,
    LOAD_STATE['In Transit'],
    LOAD_STATE['In Yard'],
    LOAD_STATE['At Dropoff'],
    LOAD_STATE.Unloading,
    LOAD_STATE.TONU,
    LOAD_STATE.Claim,
  ],
  [TAB.DELIVERED]: [LOAD_STATE.Delivered],
  [TAB.INVOICED]: [LOAD_STATE.Invoiced],
  [TAB.ARCHIVED]: [LOAD_STATE.Completed, LOAD_STATE.Cancelled],
}
export const TAB_EXTERNAL_STATUS_MAP = {
  [TAB.ALL]: TAB_STATUSES[TAB.ALL],
  [TAB.PENDING]: TAB_STATUSES[TAB.PENDING],
  [TAB.READY_FOR_DISPATCH]: TAB_STATUSES[TAB.READY_FOR_DISPATCH],
  [TAB.ACTIVE]: TAB_STATUSES[TAB.ACTIVE].filter(status => status !== LOAD_STATE.TONU),
  [TAB.DELIVERED]: {
    internal: [...TAB_STATUSES[TAB.DELIVERED], LOAD_STATE.TONU],
    external: [
      ...TAB_STATUSES[TAB.DELIVERED],
      LOAD_STATE['Payment Pending'],
      LOAD_STATE['POD Rejected'],
      LOAD_STATE.Invoiced,
      LOAD_STATE.Completed,
      LOAD_STATE.TONU,
    ],
  },
  [TAB.INVOICED]: {
    internal: TAB_STATUSES[TAB.INVOICED],
    external: [],
  },
  [TAB.ARCHIVED]: {
    internal: TAB_STATUSES[TAB.ARCHIVED],
    external: [LOAD_STATE.Cancelled],
  },
}

export const TABS = $enum(TAB).map(label => label)

export const timeTypeOptions = [
  { label: capitalize(TIME_TYPE.appointment), value: TIME_TYPE.appointment },
  { label: capitalize(TIME_TYPE.window), value: TIME_TYPE.window },
]

export const unitTypeOptions: ISelectOption<UNIT_TYPE>[] = $enum(UNIT_TYPE).map(o => ({
  label: o,
  value: o,
}))
